// The game's name, the company, and the switches that change when the game launches (2026-10-25, site kit). One place
// for every string the site prints about who we are, copied in shape from sheep-tag src/share/brand.ts. Pure: no DOM,
// no node imports.

/** The product name. "Footmen Wars" alone is also the genre's own name (StrategyWiki), so OUR game is always this. */
export const BRAND = 'Footmen Wars Online';
export const ORIGIN = 'https://footmenwars.com';
/** The other domains we own; functions/_middleware.ts sends each one (and its www) to ORIGIN with a 301. */
export const ALT_DOMAINS = ['footmenwars.online', 'footmen.online', 'footmanwars.com'];

/** The company that makes the game. Always "Tin Whistle Games" in print, never with LLC (not filed yet). */
export const STUDIO = 'Tin Whistle Games';
export const STUDIO_URL = 'https://tinwhistlegames.com/';
export const STUDIO_LD = { '@type': 'Organization', name: STUDIO, url: STUDIO_URL } as const;

/** Pre-launch the one call to action is the Discord (Devin, 2026-10-25 09:59 CT), and this is the ONE place its invite
 *  goes. A placeholder (anything with TBD) makes the build warn and no page show it (2026-11-01, launch prep): a page
 *  with no Discord and no game yet has no action button at all, rather than a dead link. The server went live on
 *  2026-11-01 (tinwhistlegames-ops docs/games/footies/DISCORD-SETUP.md, Outcome): this invite never expires, has no
 *  use limit and lands in #welcome. */
export const DISCORD_INVITE = 'https://discord.gg/G7JAQgAsBF';
/** The server "Footmen Wars Online" (DISCORD-SETUP.md, Outcome). Its widget, which is on, is keyed by this id. */
export const DISCORD_GUILD = '1566521376364429455';
/** A real invite: a discord.gg or discord.com link with no TBD in it. */
export const inviteReady = (url: string) => /^https:\/\/discord\.(gg|com)\/[\w/-]+$/.test(url) && !/TBD/i.test(url);
export const discordReady = () => inviteReady(DISCORD_INVITE);

/** Flip at launch: every page's call to action becomes Play (/play/), /play/ joins the sitemap and loses its noindex,
 *  the VideoGame JSON-LD gains its free offer, and the early access line shows. scripts/deploy.sh refuses to put
 *  footmenwars.com live until this is true. */
export const LAUNCHED = true;

/** The launch in one value (2026-11-01), so a page can be rendered, and tested, in every state: launched or not, with a
 *  real Discord invite or none. The build uses LAUNCH; tests pass their own through RenderCtx.launch. */
export interface Launch { launched: boolean; discord: string | null }
export const LAUNCH: Launch = { launched: LAUNCHED, discord: discordReady() ? DISCORD_INVITE : null };

/** The early access line (Devin's voice, one line), under the landing's Play button and in every closing call to action
 *  once LAUNCHED: the game is open, free, and not finished. */
export const EARLY_ACCESS = 'Early access: free to play in your browser while we keep building it.';

/** Team colors, the same four the game draws (src/client/main.ts TEAM_COLORS): red, blue, bronze-gold, teal. Never green. */
export const TEAM = { red: '#d8433a', blue: '#3a72d8', gold: '#d6a631', teal: '#2fa89a' } as const;

export const SISTER = { name: 'Sheep Tag Online', url: 'https://sheeptag.online/' };

/** The footer's legal line after the year. */
export const FOOT_LEGAL = `${STUDIO}. Footmen Wars Online is a new game in the footies genre. Not affiliated with or endorsed by Blizzard Entertainment. Warcraft is a trademark of Blizzard Entertainment, Inc.`;
